// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","companyChartSidebar":"NIMY9BLKZfl38G7HMlPD3","companyChartToggleList":"tnqRXRtub8QeeO_t4nKRc","active":"_3PBGRSEj7xQq3D7DGnGa41"};